<template>
  <div class="input">
    <template class="mb-1" v-if="item.tipo == `periodo`">
      <p class="mb-2">{{ item.required ? "* " : "" }}{{ item.etiqueta }}:</p>
      <DateSelector
        class="z-custom-2"
        @input="v => (_value_ = v)"
        :date="_value_"
      />
    </template>

    <template
      v-else-if="item.tipo == `select` || item.tipo == `select_multiple`"
    >
      <label>{{ item.required ? "* " : "" }}{{ item.etiqueta }}:</label>
      <vSelectC
        v-model="_value_"
        :multiple="item.tipo == `select_multiple`"
        :options="items"
        :loading="isLoadingPage"
        class="margin-multi"
        :placeholder="item.etiqueta"
      >
        <template #open-indicator="{ attributes }">
          <CIcon
            v-bind="attributes"
            style="cursor:pointer"
            name="cil-caret-bottom"
          />
        </template>
        <template #no-options>
          Sin resultados.
        </template>
      </vSelectC>
    </template>
    <template v-else-if="item.tipo == `select_local`">
      <label>{{ item.required ? "* " : "" }}{{ item.etiqueta }}:</label>
      <vSelectC
        v-model="_value_"
        :options="items"
        :loading="isLoadingPage"
        class="margin-multi"
        :placeholder="item.etiqueta"
      >
        <template #open-indicator="{ attributes }">
          <CIcon
            v-bind="attributes"
            style="cursor:pointer"
            name="cil-caret-bottom"
          />
        </template>
        <template #no-options>
          Sin resultados.
        </template>
      </vSelectC>
    </template>
    <template v-else-if="item.tipo == `select_configuracion`">
      <label>{{ item.required ? "* " : "" }}{{ item.etiqueta }}:</label>
      <vSelectC
        v-model="_value_"
        :options="items"
        :loading="isLoadingPage"
        class="margin-multi"
        :placeholder="item.etiqueta"
      >
        <template #open-indicator="{ attributes }">
          <CIcon
            v-bind="attributes"
            style="cursor:pointer"
            name="cil-caret-bottom"
          />
        </template>
        <template #no-options>
          Sin resultados.
        </template>
      </vSelectC>
    </template>
    <template v-else-if="item.tipo == `text`">
      <label>{{ item.required ? "* " : "" }}{{ item.etiqueta }}:</label>
      <CInput v-model="_value_" :placeholder="item.etiqueta" />
    </template>

    <template v-else>
      {{ item }}
    </template>
  </div>
</template>

<script>
import DateSelector from "../../../../customComponents/DateSelector";

// import { setupCalendar, DatePicker } from "v-calendar";
import moment from "moment";
// import "v-calendar/lib/v-calendar.min.css";

import "vue-select/dist/vue-select.css";

export default {
  name: "FilterInput",
  components: {
    // "v-date-picker": DatePicker,
    DateSelector
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    value: {}
  },
  computed: {
    _value_: {
      get() {
        const param = this.item;
        if ("ubicaciones" === param.nombre) {
          return this.items?.find(f => f.value === this.value?.[0]);
        }
        if ("select_multiple" === param.tipo) {
          return this.items?.filter(ff => this.value.includes(ff.value));
        }
        if (param.tipo.includes("select")) {
          return this.items?.find(f => f.value === this.value);
        }
        if ("periodo" === param.tipo) {
          if (this.value) {
            const [start, end] = this.value;
            return {
              start: moment(start, "YYYY-MM-DD HH:mm:ss").toDate(),
              end: moment(end, "YYYY-MM-DD HH:mm:ss").toDate()
            };
          }
        }
        return this.value;
      },
      set(v) {
        const param = this.item;
        if ("ubicaciones" === param.nombre) {
          return this.$emit("input", v ? [v.value] : undefined);
        }
        if ("select_multiple" === param.tipo) {
          return this.$emit("input", v ? v.map(m => m.value) : undefined);
        }
        if (param.tipo.includes("select")) {
          return this.$emit("input", v?.value || undefined);
        }
        if ("periodo" === param.tipo) {
          return this.$emit("input", [
            moment(v.start).format("YYYY-MM-DD HH:mm:ss"),
            moment(v.end).format("YYYY-MM-DD HH:mm:ss")
          ]);
        }
        this.$emit("input", v);
      }
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    ubicacionRaizItem() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation
        : null;
    }
  },
  watch: {
    value(newValue) {
      console.log("watch:value", newValue);
      this.$emit("change", { [this.item.nombre]: newValue });
    }
  },
  data() {
    return {
      isLoadingPage: false,
      items: []
    };
  },
  created() {
    if (this.item.tipo.includes("select")) {
      const param = this.item;

      if (param.nombre === "ubicaciones" && !this.value) {
        this.$emit("input", [this.ubicacionRaiz]);
      }
      if (param.config) {
        if (param.tipo === "select_local") {
          this.items = param.config.data.map(m => ({
            label: m.etiqueta,
            value: m.valor
          }));
        } else {
          this.isLoadingPage = true;
          this.GetConfig(
            param.config,
            param.nombre === "ubicaciones",
            param.tipo
          )
            .then(getConfig => {
              this.items = getConfig;
            })
            .finally(() => {
              this.isLoadingPage = false;
            });
        }
      }
    }
  },
  methods: {
    async GetConfig(_config_, isUbicaciones, tipo) {
      // TODO: {type: "cat", schema: "almacenes", etiqueta: "payload.nombre", valor: "id"} VALOR Y LABEL
      const config = JSON.parse(JSON.stringify(_config_));
      const inserUbiRoot =
        !isUbicaciones &&
        config.schema !== "configuracion" &&
        config.schema !== "ubicaciones";

      if (!config.filter) {
        config.filter = { ...(config?.filtro || {}) };
      }
      if (inserUbiRoot && !config.filter.wherein) {
        config.filter.wherein = [];
      }
      inserUbiRoot &&
        config.filter.wherein.push({
          field: "payload->ubicacion_id",
          value: this.ubicacionRaiz ? [this.ubicacionRaiz] : []
        });
      const consultar = {
        catConsultar: body => this.$store.dispatch("customHTTP", body)
      };
      console.log("GetConfig", JSON.stringify(config));
      try {
        const res = await consultar[`${config.type}Consultar`](
          {
            schema: config.schema,
            filter: config.filter
          },
          "GetConfig"
        );
        const data = res.data;

        if (tipo === "select_configuracion") {
          return data.reduce((v, c) => {
            c.payload.valor.forEach(item => {
              const valor = this.ExtractData(
                item,
                _config_.valor.replace(/\*.|.\*/g, "")
              );
              if (Array.isArray(valor)) {
                v = [
                  ...v,
                  ...valor.filter(ff=>!v.map(m=>m.value).includes(ff)).map(m => ({
                    label: `${m}`,
                    value: m
                  }))
                ].sort((a,b)=>a.label.localeCompare(b.label));
              } else {
                
                v.push({
                  label: `${valor}`,
                  value: valor
                });
              }
            });
            return v;
          }, []);
        } else {
          return data.map(m => {
            console.log(m); //, _config_.etiqueta, _config_.valor);
            return {
              label: `${this.ExtractData(m, _config_.etiqueta)}`,
              value: this.ExtractData(m, _config_.valor)
            };
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    ExtractData(data, ruta) {
      let pointer = JSON.parse(JSON.stringify(data));
      const navegacion = ruta.split(".");
      for (const key of navegacion) {
        pointer = pointer[key];
      }
      return pointer;
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style lang="scss" scoped>
.input {
  min-width: 250px;
  max-width: 250px;
}
</style>

<style scoped>
.z-custom-2 {
  z-index: 4;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.table {
  cursor: pointer;
}
.table:hover {
  color: white;
  background-color: #321fdb;
}
.detail {
  width: 100%;
  cursor: pointer;
}
.detail:hover {
  color: white;
  background-color: #321fdb;
}
.tr:hover {
  color: white;
}
.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 10%;
}
.custom-font-size {
  font-size: 1rem;
}
.custom-width {
  width: 100%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 20px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
